import {useAppDispatch} from '../../../redux/hooks';
import React, {useEffect} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {GetClasses, GetMana, GetSubclasses} from '../../../GraphQL/SystemQueries';
import {CreateMana, DeleteMana, UpdateMana} from '../../../GraphQL/SystemMutations';
import {toast} from 'react-toastify';
import {setActiveContent, setIsAppLoading} from '../../../redux/slices/content/contentSlice';
import Button from '../../../Atoms/Button';
import {DeleteSharp, PlayArrowSharp} from '@mui/icons-material';
import {PopUp} from '../../../Atoms/PopUp';
import Input from '../../../Atoms/Input';
import {DropDown} from '../../../Atoms/DropDown';
import {TextEditor} from '../../../Atoms/TextEditor';
import {ActiveContent} from '../../../redux/slices/content/contentType';
import {VeneList} from "../../../Atoms/VeneList";
import {Mana} from "../../../redux/slices/character/characterType";

export const Manatabellen = () => {
    const dispatch = useAppDispatch();

    const [ manas, setManas ] = React.useState<any[]>([]);
    const [ classes, setClasses ] = React.useState<any[]>([]);
    const [ subClasses, setSubClasses ] = React.useState<any[]>([]);
    const [ selectedMana, setSelectedMana ] = React.useState<any>(null);
    const [ deleteManaId, setDeleteManaId ] = React.useState<number>(0)
    const [ isPopUpVisible, setIsPopUpVisible ] = React.useState<boolean>(false);
    const [ isDeletePopUpVisible, setIsDeletePopUpVisible ] = React.useState(false)

    const {data: classData, loading: classLoading, error: classError} = useQuery(GetClasses, {fetchPolicy: 'network-only'});
    const {data: manaData, loading: manaLoading, error: manaError} = useQuery(GetMana, {fetchPolicy: 'network-only'});
    const {data: subclassData, loading: subclassLoading, error: subclassError} = useQuery(GetSubclasses, {fetchPolicy: 'network-only'});
    const [ createManaHook, {}] = useMutation(CreateMana);
    const [ updateManaHook, {}] = useMutation(UpdateMana);
    const [ deleteManaHook, {}] = useMutation(DeleteMana);

    useEffect(() => {
        if (classData && !classLoading) {
            const classList = [];
            for (const classObj of classData.getClasses) {
                classList.push({
                    itemValue: classObj.classId,
                    itemText: classObj.className
                })
            }
            setClasses(classList);
        }
    }, [ classData ])

    useEffect(() => {
        if (subclassData && !subclassLoading) {
            const subClassList = [];
            for (const classObj of subclassData.getSubclasses) {
                subClassList.push({
                    itemValue: classObj.subclassId,
                    itemText: classObj.subclassName
                })
            }
            setSubClasses(subClassList);
        }
    }, [ subclassData ])

    useEffect(() => {
        if (manaData && !manaLoading) {
            const manaList = [];
            for (const singleMana of manaData.getMana) {
                let isClass = singleMana.Subclass === null;
                manaList.push({
                    manaId: Number(singleMana.manaId),
                    reference: isClass? singleMana.Class.className : singleMana.Subclass.subclassName,
                    referenceId: isClass? singleMana.Class.classId : singleMana.Subclass.subclassId,
                    manaAmount: singleMana.manaAmount,
                    manaLevel: singleMana.manaLevel,
                    manaCantrips: singleMana.manaCantrips,
                    manaMaxSpells: singleMana.manaMaxSpells,
                    manaMaxSpellLevel: singleMana.manaMaxSpellLevel,
                    isClass: isClass
                })
            }
            setManas(manaList);
        }
    }, [ manaData ])

    useEffect(() => {
        if (manaError) {
            toast('Fehler beim Laden der Manatabelle')
        }
    }, [ manaError ])

    useEffect(() => {
        if (manaLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Völker werden geladen...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ manaLoading ])

    const editMana = (mana: any) => {
        setSelectedMana({
            manaId: Number(mana.manaId),
            referenceId: mana.referenceId,
            manaAmount: mana.manaAmount,
            manaLevel: mana.manaLevel,
            manaCantrips: mana.manaCantrips,
            manaMaxSpells: mana.manaMaxSpells,
            manaMaxSpellLevel: mana.manaMaxSpellLevel,
            isClass: mana.isClass
        });
        setIsPopUpVisible(true)
    }

    const deleteMana = (mana: any) => {
        setDeleteManaId(mana.manaId);
        setIsDeletePopUpVisible(true);
    }

    const handleUpdateMana = async () => {
        const updateData = await updateManaHook({
            variables: {
                manaId: Number(selectedMana.manaId),
                referenceId: Number(selectedMana.referenceId),
                manaAmount: selectedMana.manaAmount,
                manaLevel: selectedMana.manaLevel,
                manaCantrips: selectedMana.manaCantrips,
                manaMaxSpells: selectedMana.manaMaxSpells,
                manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                isClass: selectedMana.isClass
            },
            refetchQueries: [{
                query: GetMana
            }]
        })

        if (!updateData.errors) {
            toast(`Das Mana wurde gespeichert!`);
            setSelectedMana(null);
            setIsPopUpVisible(false);
        } else {
            toast(`Fehler beim Speichern des Manas!`)
        }
    }

    const handleCreateMana = async () => {
        const createData = await createManaHook({
            variables: {
                referenceId: Number(selectedMana.referenceId),
                manaAmount: selectedMana.manaAmount,
                manaLevel: selectedMana.manaLevel,
                manaCantrips: selectedMana.manaCantrips,
                manaMaxSpells: selectedMana.manaMaxSpells,
                manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                isClass: selectedMana.isClass
            },
            refetchQueries: [{
                query: GetMana
            }]
        })

        if (!createData.errors) {
            toast(`Das Mana wurde erstellt!`);
            setSelectedMana(null);
            setIsPopUpVisible(false);
        } else {
            toast(`Fehler beim Erstellen des Manas!`)
        }
    }

    const handleDeleteMana = async () => {
        const deleteData = await deleteManaHook({
            variables: {
                manaId: Number(deleteManaId),
            },
            refetchQueries: [{
                query: GetMana
            }]
        })

        if (!deleteData.errors) {
            toast(`Das Mana wurde erfolgreich gelöscht!`)
        } else {
            toast(`Fehler beim Löschen des Volkes!`)
        }

        setDeleteManaId(0);
        setIsDeletePopUpVisible(false);
    }

    const handleClosePopUp = () => {
        setSelectedMana(null);
        setIsPopUpVisible(false)
    }

    return (
        <div className="sc_mana">
            {(selectedMana !== null && isPopUpVisible) && (
                <PopUp onClose={handleClosePopUp} title='Mana bearbeiten'>
                    <div className='row justify-content-end'>
                        <div className='col-2'>
                            <Button onClick={ async () => selectedMana.manaId > 0? await handleUpdateMana() : await handleCreateMana() }>{selectedMana.manaId > 0 ? 'Speichern' : 'Erstellen'}</Button>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-2'>
                            <label>Menge:</label>
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={0} value={selectedMana.manaAmount} onChange={(e) => setSelectedMana({
                                manaId: Number(selectedMana.manaId),
                                referenceId: selectedMana.referenceId,
                                manaAmount: Number(e.target.value) > 0? Number(e.target.value) : 0,
                                manaLevel: selectedMana.manaLevel,
                                manaCantrips: selectedMana.manaCantrips,
                                manaMaxSpells: selectedMana.manaMaxSpells,
                                manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                isClass: selectedMana.isClass
                            })}/>
                        </div>
                        <div className='col-2'>
                            <label>Level:</label>
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={1} maxValue={20} value={selectedMana.manaLevel} onChange={(event) => setSelectedMana({
                                manaId: Number(selectedMana.manaId),
                                referenceId: selectedMana.referenceId,
                                manaAmount: selectedMana.manaAmount,
                                manaLevel: Number(event.target.value) > 0? Number(event.target.value) < 21? Number(event.target.value) : 20 : 1,
                                manaCantrips: selectedMana.manaCantrips,
                                manaMaxSpells: selectedMana.manaMaxSpells,
                                manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                isClass: selectedMana.isClass
                            })}/>
                        </div>
                        <div className='col-2 mt-2'>
                            <label>Klasse: </label>
                        </div>
                        <div className='col-10 text-start mt-2'>
                            <input type='checkbox' checked={selectedMana.isClass} onClick={ (event) => {
                                setSelectedMana({
                                    manaId: Number(selectedMana.manaId),
                                    referenceId: selectedMana.referenceId,
                                    manaAmount: selectedMana.manaAmount,
                                    manaLevel: selectedMana.manaLevel,
                                    manaCantrips: selectedMana.manaCantrips,
                                    manaMaxSpells: selectedMana.manaMaxSpells,
                                    manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                    isClass: !selectedMana.isClass
                                })
                            }}/>
                        </div>
                        { !selectedMana.isClass && (
                            <div className='col-12 mt-2'>
                                <DropDown value={selectedMana.referenceId} setValue={(event) => {
                                    setSelectedMana({
                                        manaId: Number(selectedMana.manaId),
                                        referenceId: event.target.value,
                                        manaAmount: selectedMana.manaAmount,
                                        manaLevel: selectedMana.manaLevel,
                                        manaCantrips: selectedMana.manaCantrips,
                                        manaMaxSpells: selectedMana.manaMaxSpells,
                                        manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                        isClass: selectedMana.isClass
                                    })
                                }} items={subClasses}/>
                            </div>
                        )}
                        { selectedMana.isClass && (
                            <div className='col-12 mt-2'>
                                <DropDown value={selectedMana.referenceId} setValue={(event) => {
                                    setSelectedMana({
                                        manaId: Number(selectedMana.manaId),
                                        referenceId: event.target.value,
                                        manaAmount: selectedMana.manaAmount,
                                        manaLevel: selectedMana.manaLevel,
                                        manaCantrips: selectedMana.manaCantrips,
                                        manaMaxSpells: selectedMana.manaMaxSpells,
                                        manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                        isClass: selectedMana.isClass
                                    })
                                }} items={classes}/>
                            </div>
                        )}
                        <div className='col-2'>
                            Anzahl Zaubertricks:
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={1} value={selectedMana.manaCantrips} onChange={(e) => setSelectedMana({
                                manaId: selectedMana.manaId,
                                referenceId: selectedMana.referenceId,
                                manaAmount: selectedMana.manaAmount,
                                manaLevel: selectedMana.manaLevel,
                                manaCantrips: Number(e.target.value) >= 1? Number(e.target.value) : 1,
                                manaMaxSpells: selectedMana.manaMaxSpells,
                                manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                isClass: selectedMana.isClass
                            })}/>
                        </div>
                        <div className='col-2'>
                            <label>Maximale Anzahl Zauber:</label>
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={1} value={selectedMana.manaMaxSpells} onChange={(event) => setSelectedMana({
                                manaId: Number(selectedMana.manaId),
                                referenceId: selectedMana.referenceId,
                                manaAmount: selectedMana.manaAmount,
                                manaLevel: selectedMana.manaLevel,
                                manaCantrips: selectedMana.manaCantrips,
                                manaMaxSpells: Number(event.target.value) >= 1? Number(event.target.value) : 1,
                                manaMaxSpellLevel: selectedMana.manaMaxSpellLevel,
                                isClass: selectedMana.isClass
                            })}/>
                        </div>
                        <div className='col-2'>
                            <label>Maximales Zauberlevel:</label>
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={1} value={selectedMana.manaMaxSpellLevel} onChange={(event) => setSelectedMana({
                                manaId: Number(selectedMana.manaId),
                                referenceId: selectedMana.referenceId,
                                manaAmount: selectedMana.manaAmount,
                                manaLevel: selectedMana.manaLevel,
                                manaCantrips: selectedMana.manaCantrips,
                                manaMaxSpells: selectedMana.manaMaxSpells,
                                manaMaxSpellLevel: Number(event.target.value) >= 1? Number(event.target.value):1,
                                isClass: selectedMana.isClass
                            })}/>
                        </div>
                    </div>
                </PopUp>
            )}
            {(selectedMana === null && !isPopUpVisible) && (
                <div>
                    { isDeletePopUpVisible && (
                        <PopUp onClose={setIsDeletePopUpVisible} title='Mana löschen'>
                            <div className='row mt-3 justify-content-center'>
                                <div className='col-12'>
                                    <b>Sind sie sicher, dass sie das Mana löschen möchten?</b>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={ async() => await handleDeleteMana() }>Löschen</Button>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={() => {
                                        setDeleteManaId(0);
                                        setIsDeletePopUpVisible(false)
                                    }}>Abbrechen</Button>
                                </div>
                            </div>
                        </PopUp>
                    )}
                    <div className='row justify-content-between'>
                        <div className='col-2'>
                            <Button onClick={() => dispatch(setActiveContent(ActiveContent.Standardinhalte))}>
                                Zurück
                            </Button>
                        </div>
                        <div className='col-2'>
                            <Button onClick={() => {
                                setSelectedMana({
                                    manaId: 0,
                                    referenceId: 0,
                                    manaAmount: 0,
                                    manaLevel: 0,
                                    manaCantrips: 0,
                                    manaMaxSpells: 0,
                                    manaMaxSpellLevel: 0,
                                    isClass: true
                                })
                                setIsPopUpVisible(true)
                            }}>
                                Hinzufügen
                            </Button>
                        </div>
                    </div>
                    <VeneList<Mana>
                        data={manas}
                        colDefinition={[
                            {
                                keyName: "manaId",
                                colName: "ID"
                            },
                            {
                                keyName: "reference",
                                colName: "Zugehörigkeit",
                            },
                            {
                                keyName: "manaLevel",
                                colName: "Level"
                            },
                            {
                                keyName: "manaAmount",
                                colName: "Menge"
                            }
                        ]}
                        buttonConfig={[
                            {
                                icon: <PlayArrowSharp/>,
                                onClick: (dataEntry) => { editMana(dataEntry) }
                            },
                            {
                                icon: <DeleteSharp/>,
                                onClick: (dataEntry) => { deleteMana(dataEntry) }
                            }
                        ]}
                    />
                </div>
            )}
        </div>
    )
}